module.exports = __webpack_public_path__ + "static/media/view1.d4435d71.jpg";